(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('OrderSummaryNav', OrderSummaryNav);

    OrderSummaryNav.$inject = ['$state', '$window', 'Principal', 'ProfileService'];

    /**
     * Role-aware navigation back to the order page. The order "parties" (appraisers and originators)
     * are sent to the new v2 order summary app (/v2/order-summary/{id}); VC staff keep the legacy
     * AngularJS state.
     *
     * Callers are the enumerated report-builder redirects and the message-board "Review Appraisal"
     * links — we intentionally do NOT add a global guard, so users retain direct access to the legacy
     * page (bookmarks, typed URL). (Report-builder sites are only ever reached by appraisers; the
     * originator half of the rule matters on the message boards.)
     */
    function OrderSummaryNav($state, $window, Principal, ProfileService) {

        var ORDER_PARTY_REGEX = /^ROLE_(APPRAISER|APPRAISAL|ORIGINATOR).*/;

        return {
            // Order overview.
            goToOrderSummary: function(orderId) {
                return orderPartyAwareRedirect(
                    '/v2/order-summary/' + orderId,
                    function() { $state.go('appraisal-order-detail', { id: orderId }); });
            },
            // Messages tab — the appraiser's primary conversation is the appraiser<->VC chat.
            goToOrderSummaryMessages: function(orderId) {
                return orderPartyAwareRedirect(
                    '/v2/order-summary/' + orderId + '?tab=messages',
                    function() { $state.go('appraisal-note-messageboard', { id: orderId }); });
            }
        };

        // Order party (appraiser/originator) -> the v2 order-summary path; everyone else -> legacy();
        // any auth/profile failure also falls back to legacy() so the user is never left stranded.
        function orderPartyAwareRedirect(v2Path, legacy) {
            return Principal.matchAnyAuthority(ORDER_PARTY_REGEX).then(function(isOrderParty) {
                if (!isOrderParty) {
                    legacy();
                    return;
                }
                return ProfileService.getProfileInfo().then(function(profile) {
                    // The order summary is its own v2 app (distinct host/port from the v2 ordering app,
                    // e.g. localhost:3004 locally). Fall back to the current host where the v2 apps are
                    // path-routed under one host (deployed envs).
                    var baseUrl = (profile && profile.v2OrderSummaryBaseUrl) ||
                        ($window.location.protocol + '//' + $window.location.host);
                    $window.location.href = baseUrl + v2Path;
                });
            }).catch(legacy);
        }
    }
})();
